import css_text from '/srv/www/htdocs/loc/app/styles/web_components/inline_message.css';

function get_shared_sheet() {
	if (get_shared_sheet.cached) {
		return get_shared_sheet.cached;
	}
	const sheet = new CSSStyleSheet();
	sheet.replaceSync(css_text);
	get_shared_sheet.cached = sheet;
	return sheet;
}

class YalwaInlineMessage extends HTMLElement {

	static get observedAttributes() {
		return ['intent', 'icon_on'];
	}

	constructor() {
		super();
		this.wrapper = null;
		if (!this.shadowRoot) {
			this.attachShadow({mode: 'open'});
		}
		this.apply_css();
	}

	async apply_css() {
		await yalwa.basics.check_stylesheet_polyfill_needed();
		this.shadowRoot.adoptedStyleSheets = [get_shared_sheet()];
	}

	connectedCallback() {
		this.initialize_template();
		this.render();
		jQuery(this).removeClass('invisible');
	}

	attributeChangedCallback(name, old_value, new_value) {
		if (old_value !== new_value) {
			this.render();
		}
	}

	initialize_template() {
		if (!this.shadowRoot.firstChild) {
			const intent = this.getAttribute('intent') || 'info';
			const icon_on = this.hasAttribute('icon_on') ? this.getAttribute('icon_on') : 'true';
			const role = (intent === 'error' || intent === 'warning') ? 'alert' : 'status';

			let icon_html = '';
			if (icon_on !== 'false') {
				const default_icon = YalwaInlineMessage.default_icon(intent);
				icon_html = `<span class="icon"><slot name="icon">${default_icon}</slot></span>`;
			}

			const template = document.createElement('template');
			template.innerHTML = `
				<div class="wrapper" role="${role}" data-intent="${intent}" data-icon_on="${icon_on}">
					${icon_html}
					<span class="text">
						<slot></slot>
					</span>
				</div>
			`;
			this.shadowRoot.appendChild(template.content.cloneNode(true));
		}
		this.wrapper = this.shadowRoot.querySelector('.wrapper');
	}

	render() {
		if (!this.wrapper) {
			return;
		}
		const intent = this.getAttribute('intent') || 'info';
		const icon_on = this.hasAttribute('icon_on') ? this.getAttribute('icon_on') : 'true';
		const role = (intent === 'error' || intent === 'warning') ? 'alert' : 'status';

		this.wrapper.setAttribute('data-intent', intent);
		this.wrapper.setAttribute('data-icon_on', icon_on);
		this.wrapper.setAttribute('role', role);

		// sync icon presence with icon_on state
		const existing_icon = this.shadowRoot.querySelector('.icon');
		const icon_slot = this.shadowRoot.querySelector('slot[name="icon"]');

		if (icon_on !== 'false') {
			// icon should be visible
			if (!existing_icon) {
				// create icon span before the text span
				const text_span = this.shadowRoot.querySelector('.text');
				const default_icon = YalwaInlineMessage.default_icon(intent);
				const icon_span = document.createElement('span');
				icon_span.className = 'icon';
				icon_span.innerHTML = `<slot name="icon">${default_icon}</slot>`;
				this.wrapper.insertBefore(icon_span, text_span);
			} else if (icon_slot && icon_slot.assignedNodes().length === 0) {
				// update existing default icon
				const img = existing_icon.querySelector('img');
				if (img) {
					img.remove();
				}
				existing_icon.insertAdjacentHTML('beforeend', YalwaInlineMessage.default_icon(intent));
			}
		} else {
			// icon should be hidden — remove the icon span
			if (existing_icon) {
				existing_icon.remove();
			}
		}
	}

	static default_icon(intent) {
		const icon_map = {
			'error': 'danger',
			'warning': 'warning',
			'success': 'success',
			'info': 'info_default'
		};
		const icon_name = icon_map[intent] || 'info_default';
		return yalwa.basics.yimage(icon_name, {pixel: 14, folder: 'main'});
	}
}

customElements.define('yalwa-inline-message', YalwaInlineMessage);
